import { useEffect, useRef, useState } from 'react';
import { Author, loadAuthors } from '../data/authors';

export const useAuthors = () => {
  const [authors, setAuthors] = useState<Author[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const requestIdRef = useRef(0);

  useEffect(() => {
    const requestId = ++requestIdRef.current;
    setLoading(true);
    setError(null);

    loadAuthors()
      .then((result) => {
        if (requestId === requestIdRef.current) {
          setAuthors(result);
          setError(null);
        }
      })
      .catch((err) => {
        if (requestId === requestIdRef.current) {
          setError(err as Error);
        }
      })
      .finally(() => {
        if (requestId === requestIdRef.current) {
          setLoading(false);
        }
      });

    return () => {
      requestIdRef.current++;
    };
  }, []);

  return {
    authors,
    loading,
    error
  };
};
